// fileUtils.js
import { DownloadService } from "../services/downloadService";

const getFileType = (fileExtension) => {
  switch (fileExtension.toLowerCase()) {
    case "csv":
      return "text/csv";
    case "doc":
      return "application/msword";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "ppt":
      return "application/vnd.ms-powerpoint";
    case "pptx":
      return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    case "xls":
      return "application/vnd.ms-excel";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "pdf":
      return "application/pdf";
    case "png":
      return "image/png";
    case "jpeg":
    case "jpg":
      return "image/jpeg";
    case "gif":
      return "image/gif";
    case "txt":
      return "text/plain";
    default:
      return "application/octet-stream";
  }
};

const downloadFile = (fileId, fileName) => {
  var fileService = new DownloadService();
  fileService
    .retrieveDownloadDocument(fileId)
    .then((data) => {
      const fileExtension = data.data.documentName.split(".").pop();
      const fileType = getFileType(fileExtension);

      const decodedFile = window.atob(data.data.documentBase64String);
      const byteArray = new Uint8Array(decodedFile.length);
      for (let i = 0; i < decodedFile.length; ++i) {
        byteArray[i] = decodedFile.charCodeAt(i);
      }

      const blob = new Blob([byteArray], { type: fileType });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => console.error(error));
};

export default downloadFile;
